import {
  pgTable,
  uuid,
  varchar,
  boolean,
  index,
  integer,
  text,
} from 'drizzle-orm/pg-core';
import { defaultFields } from '@trashlab/api/drizzle/default';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { sql } from 'drizzle-orm';

/**
 * Represents a business line configuration for organizing business records.
 * Business lines categorize services and operations like Rolloff, Residential, Commercial, etc.
 * This allows organizations to organize customers, orders, and other business records by service type.
 */
export const business_line_config = pgTable(
  'business_line_config',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    /** Display name of the business line */
    name: varchar('name', { length: 255 }).notNull(),
    /** Optional detailed description of the business line */
    description: text('description'),
    /** Default auto-send setting for subscriptions in this business line */
    autoSendInvoice: boolean('autoSendInvoice').notNull().default(false),
  },
  (table) => {
    return {
      createdAtTs_idx: index('business_line_config_createdAtTs_idx').on(table.createdAtTs),
      tenantId_idx: index('business_line_config_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('business_line_config_updatedAtTs_idx').on(table.updatedAtTs),
      updatedAtTs_idx_desc: index('business_line_config_updatedAtTs_idx_desc').on(table.updatedAtTs.desc()),
      versionNumber_idx: index('business_line_config_versionNumber_idx').on(table.versionNumber),
      name_idx: index('business_line_config_name_idx').on(table.name),
      name_trgm_idx: index('business_line_config_name_trgm_idx').using(
        'gin',
        sql`${table.name} public.gin_trgm_ops`,
      ),
      tenant_display_page_active_idx: index(
        'business_line_tenant_display_page_active_idx',
      )
        .on(
          table.tenantId,
          sql`lower(left(btrim(name), 48) COLLATE "C") COLLATE "C"`,
          sql`left(btrim(name), 48) COLLATE "C"`,
          sql`md5(btrim(name)) COLLATE "C"`,
          table.id,
        )
        .where(sql`${table.archivedAtTs} IS NULL`),
    };
  },
);

// Export Zod schemas for validation
export const BusinessLineConfigInsertSchema = createInsertSchema(business_line_config);
export const BusinessLineConfigSelectSchema = createSelectSchema(business_line_config);
